import { render, staticRenderFns } from "./PortalSubscription.vue?vue&type=template&id=4e43e29e"
import script from "./PortalSubscription.vue?vue&type=script&lang=js"
export * from "./PortalSubscription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports